import { onDocumentReady } from '../utils/events';

/**
 * Toggle a solid header background once the user scrolls away from the top.
 * On the home template the header sits transparently over the hero until then.
 */
onDocumentReady(() => {
  const header = document.querySelector('.header');
  if (!header) return;

  const navigation = header.querySelector('.main-menu-container');
  const isHome = document.body.classList.contains(
    'page-template-template-home'
  );
  const desktopMedia = window.matchMedia('(min-width: 1024px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;
  let initialized = false;
  let navigationAnimation;

  const update = () => {
    const isScrolled = window.scrollY > 0;

    if (!initialized) {
      header.classList.toggle('is-scrolled', isScrolled);
      initialized = true;
      ticking = false;
      return;
    }

    if (header.classList.contains('is-scrolled') === isScrolled) {
      ticking = false;
      return;
    }

    const shouldAnimate =
      isHome && navigation && desktopMedia.matches && !reducedMotion.matches;
    const previousLeft = shouldAnimate
      ? navigation.getBoundingClientRect().left
      : 0;

    if (navigationAnimation) navigationAnimation.cancel();
    header.classList.toggle('is-scrolled', isScrolled);

    if (shouldAnimate) {
      const currentLeft = navigation.getBoundingClientRect().left;
      const offset = previousLeft - currentLeft;

      navigationAnimation = navigation.animate(
        [
          { transform: `translateX(${offset}px)` },
          { transform: 'translateX(0)' },
        ],
        { duration: 400, easing: 'ease-in-out' }
      );
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
});
